interface UserInfoProps {
  email?: string | null
  displayName?: string | null
  onSwitchAccount?: () => void
}

export function UserInfo({ email, displayName, onSwitchAccount }: UserInfoProps) {
  return (
    <div className="flex items-center justify-between rounded-lg bg-[var(--bg-elevated)] px-4 py-3">
      <div className="text-sm">
        <span className="text-[var(--text-secondary)]">Signed in as </span>
        <span className="font-medium text-[var(--text-primary)]">
          {displayName || email || 'Unknown'}
        </span>
      </div>
      {onSwitchAccount && (
        <button
          onClick={onSwitchAccount}
          className="text-sm font-medium text-[var(--text-primary)] hover:opacity-80 transition-opacity"
        >
          Not you?
        </button>
      )}
    </div>
  )
}
